import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';

import { startSession } from '../../../utils/session-timer';

import { requestSocialLogin } from '../../../api/social-login/social-login.actions';

const SocialLoginContainer = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const code = urlParams.get('code');
  const params = useParams();
  const type = params.type;

  useEffect(() => {
    if (code) {
      dispatch(
        requestSocialLogin({
          input: { authorizationCode: code, type },
          onSuccess: () => {
            startSession();
            navigate('/dashboard');
          },
          navigate: navigate,
        })
      );
    }
  }, [dispatch, code, navigate, type]);
};

export default SocialLoginContainer;
